module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C587"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("ACKNOWLEDGMENTS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C606"
  }, [_vm._v("Thanks to the "), _c('em', [_vm._v("International Journal of Žižek Studies ")]), _vm._v("for permission to publish a revised version of the essay that appeared as “The Violence of Creation in "), _c('em', [_vm._v("The Prestige")]), _vm._v(",” "), _c('em', [_vm._v("International Journal of Žižek Studies ")]), _vm._v("1, no. 3 (2007): "), _c('a', {
    attrs: {
      "href": "http://zizekstudies.org/index.php/ijzs/article/view/58/120",
      "target": "_blank"
    }
  }, [_vm._v("http://zizekstudies.org/index.php/ijzs/article/view/58/120")]), _vm._v(". Thanks also to "), _c('em', [_vm._v("Jump Cut ")]), _vm._v("for permission to publish a revised version of the essay that appeared as “The Hero’s Form of Appearance: The Necessary Darkness of "), _c('em', [_vm._v("The Dark Knight")]), _vm._v(",” "), _c('em', [_vm._v("Jump Cut ")]), _vm._v("51 (2009): "), _c('a', {
    attrs: {
      "href": "http://www.ejumpcut.org/archive/jc51.2009/darkKnightKant/index.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.ejumpcut.org/archive/jc51.2009/darkKnightKant/index.html")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("I owe a tremendous debt to my students at the University of Vermont, who have constantly advanced my thinking about cinema in general and Christopher Nolan in particular. I’m also thankful for the support and generosity of my colleagues within film studies at the University of Vermont—Dave Jenemann, Sarah Nilsen, Hyon Joo Yoo, Deb Ellis, and Hilary Neroni. Outside of film studies, Joseph Acquisto, John Waldron, Emily Bernard, and Eric Lindstrom have been invaluable. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("Thanks to Andrew Barnaby for reading and providing extensive commentary for the chapter on "), _c('em', [_vm._v("Memento")]), _vm._v(". The inspiration for that chapter came from our joint teaching of the film. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("I am grateful to Jonathan Mulroney for his catholic perspective, which sees what I tend to overlook. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("I appreciate Jean Wyatt and Quentin Martin’s careful reading of the chapter on "), _c('em', [_vm._v("Inception")]), _vm._v(". Whatever clarity it now has is due in no small part to their efforts. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("Thanks to Slavoj Žižek for his many forms of assistance and generosity, which are always done without concern for recognition or plaudits. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("Sarah Nilsen and Michael Ashooh provided challenges to my certitudes and infusions of new thinking. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("Danny Cho read several chapters and provided suggestions that sprouted into entire new sections of the book. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("I am grateful to Jennifer Friedlander for her invitation to speak on "), _c('em', [_vm._v("Inception ")]), _vm._v("at Pomona College and for her penetrating questions. Most of all, I am indebted to her and Henry Krips for being theoretical comrades. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("Thanks to Sheila Kunkle, who has provided years of dialogue and incessant construction of new forms of fiction, without which I would be floundering. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_c('span', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("I ")]), _vm._v("am grateful to Fabio Vighi, whose reading of the entire book helped to make the philosophical arguments evident to me. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("Hugh Manon provided so much additional information for the book that, if the book were better, he should be listed as a coauthor. His reading was one of the most detailed I have ever received, and his insights were always clear and to the point. ")]), _vm._v(" "), _c('p', {
    staticClass: "P44"
  }, [_vm._v("Walter Davis, Paul Eisenstein, and Hilary Neroni have all traced the logic of my lies to the point of truth, for which my debt remains inexpressible. My relationship with each has become one of true speculative identity. ")]), _vm._v(" "), _c('p', {
    staticClass: "C841"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("THE ")]), _vm._v("FICTIONAL CHRISTOPHER NOLAN ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17abc4a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_ACKNOWLE.vue
// module id = 75
// module chunks = 0